module.exports = __webpack_public_path__ + "static/media/banho-de-assento-1.75f68456.png";